<div id = "footer-container">
<div class="ge5p_global_styles gn-ds2 footer-container" *ngIf="!isNumberSyncFlow" [attr.aria-disabled]="trapFocusForCato">
   <div id="ge5p_z7">
      <footer style="display: block;">
         <div id="gn-zone5">
            <div id="z5-footer-content" class="container"
               [ngStyle]="{'margin-left.px': hideActivationFooter ? '0' : ''}">
               <div *ngIf="hideFooter">
                  <div class="row">
                     <div id="z5-footer-links" class="span12">
                        <div id="z5-ftr-col1" class="span12-sm span3 span4-md FNSeparator">
                           <div>
                              <div class="parbase linkContainer section">
                                 <ul class="no-bullet">
                                    <li class="hide-sm hide-xsm" *ngIf="(showfirstnetlocalcontrol && !isAgentFacing)">
                                       <a id="link_firstnetlocal_desktop"
                                          href="{{cfetNavLinks.footer_links.firstnet_central}}"
                                          aria-label="FirstNet Central" target="_self" (click)="onFirstnetCentral()">
                                          {{cfetNavLables.footer_menu.firstnet_central}}
                                       </a>
                                    </li>
                                    <li class="hide-lg hide-md" *ngIf="(showfirstnetlocalcontrol && !isAgentFacing)">
                                       <a id="link_firstnetlocal_mobile"
                                          href="{{cfetNavLinks.footer_links.firstnet_central}}"
                                          aria-label="FirstNet Central" target="_self" (click)="onFirstnetCentral()">
                                          {{cfetNavLables.footer_menu.firstnet_central}}
                                       </a>
                                    </li>
                                    <li class="hide-sm hide-xsm" *ngIf="(showDeviceAndService && !isAgentFacing)">
                                       <a id="link_d&s_desktop" href="{{cfetNavLinks.footer_links.devices_services}}"
                                          aria-label="Devices &amp; service " target="_self"
                                          (click)="onDevicesServices()">
                                          {{cfetNavLables.footer_menu.devices_service}}
                                       </a>
                                    </li>
                                    <li class="hide-lg hide-md" *ngIf="(showDeviceAndService && !isAgentFacing)">
                                       <a id="link_d&s_mobile" href="{{cfetNavLinks.footer_links.devices_services}}"
                                          aria-label="Devices &amp; service " target="_self"
                                          (click)="onDevicesServices()">
                                          {{cfetNavLables.footer_menu.devices_service}}
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                        <div id="z5-ftr-col2" class="span12-sm span6 span4-md FNSeparator">
                           <div>
                              <div class="parbase linkContainer section">
                                 <ul class="no-bullet ">
                                    <li class="hide-sm hide-xsm">
                                       <a id="link_aboutfirstnet_desktop"
                                          href="{{cfetNavLinks.footer_links.about_firstnet}}"
                                          aria-label="About FirstNet " target="_self" (click)="onAboutFirstnet()">
                                          {{cfetNavLables.footer_menu.about_firstnet}}
                                       </a>
                                    </li>
                                    <li class="hide-lg hide-md">
                                       <a id="link_aboutfirstnet_mobile"
                                          href="{{cfetNavLinks.footer_links.about_firstnet}}"
                                          aria-label="About FirstNet " target="_self" (click)="onAboutFirstnet()">
                                          {{cfetNavLables.footer_menu.about_firstnet}}
                                       </a>
                                    </li>
                                    <li class="hide-sm hide-xsm" *ngIf="isFirstnetSiteMap">
                                       <a id="link_firstnetmap_desktop"
                                          href="{{cfetNavLinks.footer_links.firstnet_site_map}}"
                                          aria-label="FirstNet Site map " target="_self" (click)="onFirstnetSiteMap()">
                                          {{cfetNavLables.footer_menu.firstnet_site_map}}
                                       </a>
                                    </li>
                                    <li class="hide-lg hide-md" *ngIf="isFirstnetSiteMap">
                                       <a id="link_firstnetmap_mobile"
                                          href="{{cfetNavLinks.footer_links.firstnet_site_map}}"
                                          aria-label="FirstNet Site map " target="_self" (click)="onFirstnetSiteMap()">
                                          {{cfetNavLables.footer_menu.firstnet_site_map}}
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                        <div class="clearfix"></div>
                     </div>
                  </div>
                  <div id="z5-footer-legal" class="row">
                     <div class="span12">
                        <div>
                           <div class="parbase linkContainer section">
                              <ul class="ftr-legal-links clear-fix">
                                 <li class="hide-sm hide-xsm">
                                    <a id="link_privacypolicy_desktop"
                                       href="{{cfetNavLinks.footer_links.privacy_policy}}" aria-label="Privacy notice "
                                       target="_self" (click)="onPrivacyPolicy()">
                                       {{cfetNavLables.footer_menu.privacy_policy}}
                                    </a>
                                 </li>
                                 <li class="hide-lg hide-md" style="height: 20px;">
                                    <a id="link_privacypolicy_mobile"
                                       href="{{cfetNavLinks.footer_links.privacy_policy}}" aria-label="Privacy notice "
                                       target="_self" (click)="onPrivacyPolicy()">
                                       {{cfetNavLables.footer_menu.privacy_policy}}
                                    </a>
                                 </li>
                                 <li class="hide-sm hide-xsm">
                                    <a id="link_terms_desktop" href="{{cfetNavLinks.footer_links.terms_of_use}}"
                                       aria-label="Terms of use " target="_self" (click)="onTermsOfUse()">
                                       {{cfetNavLables.footer_menu.terms_of_use}}
                                    </a>
                                 </li>
                                 <li class="hide-lg hide-md" style="height: 20px;">
                                    <a id="link_terms_mobile" href="{{cfetNavLinks.footer_links.terms_of_use}}"
                                       aria-label="Terms of use " target="_self" (click)="onTermsOfUse()">
                                       {{cfetNavLables.footer_menu.terms_of_use}}
                                    </a>
                                 </li>
                                 <li class="hide-sm hide-xsm">
                                    <a id="link_firstnetlocalcontrol_desktop"
                                       href="{{cfetNavLinks.footer_links.firstnet_central}}"
                                       aria-label="FirstNet Central" target="_self" (click)="onFirstnetCentral()">
                                       {{cfetNavLables.footer_menu.firstnet_central}}
                                    </a>
                                 </li>
                                 <li class="hide-lg hide-md" style="height: 20px;">
                                    <a id="link_firstnetlocalcontrol_mobile"
                                       href="{{cfetNavLinks.footer_links.firstnet_central}}"
                                       aria-label="FirstNet Central" target="_self" (click)="onFirstnetCentral()">
                                       {{cfetNavLables.footer_menu.firstnet_central}}
                                    </a>
                                 </li>
                                 <li class="hide-sm hide-xsm">
                                    <a id="link_contact_desktop" href="{{cfetNavLinks.footer_links.contact_us}}"
                                       aria-label="Contact us " target="_self" (click)="onContactUs()">
                                       {{cfetNavLables.footer_menu.contact_us}}
                                    </a>
                                 </li>
                                 <li class="hide-lg hide-md" style="height: 20px;">
                                    <a id="link_contact_mobile" href="{{cfetNavLinks.footer_links.contact_us}}"
                                       aria-label="Contact us " target="_self" (click)="onContactUs()">
                                       {{cfetNavLables.footer_menu.contact_us}}
                                    </a>
                                 </li>
                                 <li class="hide-sm hide-xsm">
                                    <a id="link_personal_information_desktop"
                                       href="{{cfetNavLinks.footer_links.personal_information}}"
                                       aria-label="Your Privacy Choices" target="_self"
                                       (click)="onPersonalInformation()">
                                       {{cfetNavLables.footer_menu.personal_information}} <img class="ccpa_icon" src="assets/images/privacyoptions.svg" alt="California Consumer Privacy Act (CCPA) Opt-Out Icon">                                    </a>
                                 </li>
                                 <li class="hide-lg hide-md personal_information_mobile" style="height: 20px;">
                                    <a id="link_personal_information_mobile"
                                       href="{{cfetNavLinks.footer_links.personal_information}}"
                                       aria-label="Your Privacy Choices" target="_self"
                                       (click)="onPersonalInformation()">
                                       {{cfetNavLables.footer_menu.personal_information}} <img class="ccpa_icon" src="assets/images/privacyoptions.svg" alt="California Consumer Privacy Act (CCPA) Opt-Out Icon">                                    </a>
                                 </li>
                                 <li class="hide-sm hide-xsm">
                                    <a id="link_health_desktop" href="{{cfetNavLinks.footer_links.health_notice}}"
                                       aria-label="Health Privacy Notice " target="_self" (click)="onHealthNotice()">
                                       {{cfetNavLables.footer_menu.health_notice}}
                                    </a>
                                 </li>
                                 <li class="hide-lg hide-md" style="height: 20px;">
                                    <a id="link_health_mobile" href="{{cfetNavLinks.footer_links.health_notice}}"
                                       aria-label="Health Privacy Notice " target="_self" (click)="onHealthNotice()">
                                       {{cfetNavLables.footer_menu.health_notice}}
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div id="z5-footer-copyright" class="row">
                     <div class="span12">
                        <div class="span9 span12-xsm span12-sm span9-md pull-left">
                           <div>
                              <div class="parbase section text">
                                 <div>
                                    <p><a title="Intellectual Property" id="link_propertyrights" target="_self"
                                          tabindex="0"
                                          (click)="onIntellectualProperty()"><u>{{intellectual_property}}</u></a>
                                       {{cfetNavLables.footer_menu.rights}}
                                    </p>
                                    <p>&nbsp;</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <!-- jit start -->
               <div class="jitFooter" *ngIf="hideActivationFooter">
                  <div id="z5-footer-legal" class="row">
                     <div class="span12">
                        <p id="label_att">{{cfetNavLables.footer_menu.website_maintain_info}}</p>
                        <div class="parbase linkContainer section">
                           <ul class="ftr-legal-links clear-fix">
                              <li class="hide-sm hide-xsm jitFooterLinks">
                                 <a id="link_privacypolicy_desktop" href="{{cfetNavLinks.footer_links.privacy_policy}}"
                                    aria-label="Privacy policy " target="_self" (click)="onPrivacyPolicy()">
                                    {{cfetNavLables.footer_menu.privacy_policy}}
                                 </a>
                              </li>
                              <li class="hide-lg hide-md jitFooterLinks" style="height: 20px;">
                                 <a id="link_privacypolicy_mobile" href="{{cfetNavLinks.footer_links.privacy_policy}}"
                                    aria-label="Privacy policy " target="_self" (click)="onPrivacyPolicy()">
                                    {{cfetNavLables.footer_menu.privacy_policy}}
                                 </a>
                              </li>
                              <li class="hide-sm hide-xsm jitFooterLinks">
                                 <a id="link_terms_desktop" href="{{cfetNavLinks.footer_links.terms_of_use}}"
                                    aria-label="Terms of use " target="_self" (click)="onTermsOfUse()">
                                    {{cfetNavLables.footer_menu.terms_of_use}}
                                 </a>
                              </li>
                              <li class="hide-lg hide-md jitFooterLinks" style="height: 20px;">
                                 <a id="link_terms_mobile" href="{{cfetNavLinks.footer_links.terms_of_use}}"
                                    aria-label="Terms of use " target="_self" (click)="onTermsOfUse()">
                                    {{cfetNavLables.footer_menu.terms_of_use}}
                                 </a>
                              </li>
                              <li class="hide-sm hide-xsm jitFooterLinks">
                                 <a id="link_personal_information_desktop"
                                    href="{{cfetNavLinks.footer_links.personal_information}}"
                                    aria-label="Your Privacy Choices" target="_self"
                                    (click)="onPersonalInformation()">
                                    {{cfetNavLables.footer_menu.personal_information}} <img class="ccpa_icon" src="assets/images/privacyoptions.svg" alt="California Consumer Privacy Act (CCPA) Opt-Out Icon">
                                 </a>
                              </li>
                              <li class="hide-lg hide-md jitFooterLinks personal_information_mobile"
                                 style="height: 20px;">
                                 <a id="link_personal_information_mobile"
                                    href="{{cfetNavLinks.footer_links.personal_information}}"
                                    aria-label="Your Privacy Choices" target="_self"
                                    (click)="onPersonalInformation()">
                                    {{cfetNavLables.footer_menu.personal_information}} <img class="ccpa_icon" src="assets/images/privacyoptions.svg" alt="California Consumer Privacy Act (CCPA) Opt-Out Icon">
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>

                  <div id="z5-footer-copyright" class="row">
                     <div class="span12">
                        <div class="span9 span12-xsm span12-sm span9-md pull-left">
                           <div>
                              <div class="parbase section text">
                                 <div class="jitFooterLinks">
                                    <p><a title="Intellectual Property" id="jit_link_propertyrights"
                                          class="jit_link_propertyrights" target="_self"
                                          (click)="onIntellectualPropertyActivation()"><u>{{intellectual_property}}</u></a><span>{{cfetNavLables.footer_menu.rights}}</span>
                                    </p>
                                    <p>&nbsp;</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <!-- jit end -->
            </div>
         </div>
      </footer>
   </div>
</div>
</div>